/**
 * @description
 * Marketplace service for managing marketplace configuration and deployment testing.
 *
 * @author AI Developer <ai@byteable.ai>
 * @date January 8, 2025
 */

import { BaseAPIClient } from "../core/base-client";
import type { MarketplaceConfig } from "./types";

/**
 * Marketplace service for managing marketplace configuration
 */
export class MarketplaceService extends BaseAPIClient {
  /**
   * Get marketplace configuration
   */
  async getMarketplaceConfig(): Promise<MarketplaceConfig> {
    return this.request<MarketplaceConfig>('/marketplace-config');
  }

  /**
   * Update marketplace configuration
   */
  async updateMarketplaceConfig(data: any): Promise<MarketplaceConfig> {
    return this.request<MarketplaceConfig>('/marketplace-config', {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  /**
   * Test marketplace deployment
   */
  async testMarketplaceDeployment(): Promise<any> {
    return this.request<any>('/marketplace-config/deployment/test', {
      method: 'POST',
    });
  }
}

// Export singleton instance
export const marketplaceService = new MarketplaceService();
